import actions from './actions'

const initialState = {
  subscribePlanOngoingData: [],
  subscribePlanOngoingLink: '',
  subscribePlanAppData: [],
  subscribeTotalCharge: 0,
  subscribeDowngradeAtEOT: true,
  appUsageAndOverages: [],
  fetchedInsightsData: [],
  appUsageAndOveragesLoading: false,
  billingInvoices: [],
}

export default function billingReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
